import { useEffect, useState } from 'react';
import { Star } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function TestimonialBanner() {
  const [reviews, setReviews] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await fetch(`${API}/reviews/public?limit=10`);
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) setReviews(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error('Failed to load testimonials', e);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (reviews.length <= 1) return;
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % reviews.length);
    }, 6000);
    return () => clearInterval(t);
  }, [reviews.length]);

  if (reviews.length === 0) return null;

  const current = reviews[index];

  return (
    <div
      className="relative z-10 max-w-3xl mx-auto px-6 pb-16"
      data-testid="testimonial-banner"
    >
      <div className="glass rounded-2xl glow-box-magenta p-6 md:p-8 border border-[#ff00ff]/30 transition-all">
        <div className="flex items-center space-x-1 mb-3 justify-center">
          {Array.from({ length: current.rating || 5 }).map((_, i) => (
            <Star
              key={i}
              size={20}
              className="fill-[#ffa500] text-[#ffa500]"
              data-testid={`testimonial-star-${i}`}
            />
          ))}
        </div>

        <p
          className="text-[#00f0ff] text-base md:text-lg text-center italic leading-relaxed mb-4"
          data-testid="testimonial-text"
          key={current.review_id}
        >
          “{current.review_text}”
        </p>

        <div className="text-center">
          <span className="text-[#ff00ff] font-semibold" data-testid="testimonial-author">
            — {current.display_name || 'A customer'}
          </span>
          {current.ticket_title && (
            <span className="text-[#00f0ff]/50 text-sm ml-2">
              · {current.ticket_title}
            </span>
          )}
        </div>

        {reviews.length > 1 && (
          <div className="flex justify-center space-x-2 mt-5">
            {reviews.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                aria-label={`Show testimonial ${i + 1}`}
                className={`h-2 rounded-full transition-all ${
                  i === index
                    ? 'w-6 bg-[#ff00ff]'
                    : 'w-2 bg-[#00f0ff]/30 hover:bg-[#00f0ff]/60'
                }`}
                data-testid={`testimonial-dot-${i}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TestimonialBanner;
